import { theme } from "../../../../theme";
import { StyleSheet } from "react-native";
export const styles = StyleSheet.create({
    input: {
        borderWidth: 1,
        borderColor: theme.colors.greyscale.lighter,
        borderRadius: theme.spacing.xsmall2,
    },
    clearButtonContainer: {
        alignItems: "flex-end",
        marginTop: theme.spacing.xsmall2,
        marginRight: theme.spacing.xsmall2,
    },
    clearButton: {
        justifyContent: "flex-end",
    },
});
//# sourceMappingURL=InputSignature.styles.js.map